var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "notice",
      style: {
        background: _vm.datas.backgroundColor,
        border: "1px solid " + _vm.datas.backgroundColor,
        "border-radius": _vm.datas.borderRadius + "px",
      },
    },
    [
      _c(
        "section",
        {
          staticClass: "searchs",
          style: {
            height: _vm.datas.height + "px",
          },
        },
        [
          _c("div", { staticClass: "search-left" }, [
            _c("i", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.datas.showIcon,
                  expression: "datas.showIcon",
                },
              ],
              staticClass: "zdy-icon icon-notice",
              style: { height: "17px", width: "17px" },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                style: {
                  "font-size": _vm.datas.textSize + "px",
                  color: _vm.datas.textColor,
                },
              },
              [_vm._v(_vm._s(_vm.datas.content))]
            ),
            _vm._v(" "),
            _c(
              "p",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.datas.more.show,
                    expression: "datas.more.show",
                  },
                ],
                staticClass: "more",
                style: {
                  "font-size": _vm.datas.more.fontSize + "px",
                  color: _vm.datas.textColor,
                },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.datas.more.type === 2 ? "" : _vm.datas.more.text
                    ) +
                    "\n          "
                ),
                _c("span", [
                  _vm._v(" " + _vm._s(_vm.datas.more.type === 0 ? "" : ">")),
                ]),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm._t("deles"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }